import React, { Fragment } from 'react'
import { Container } from 'react-bootstrap'
import { FooterLogo } from '../assets/images'
import "../styles/custom-styles.css"
import "../styles/responsive.css"

const FooterComp = () => {

  return (
    <Fragment>
      <footer>
        <Container>
          <div className='footer-contents'>
            <div className='footer-logo'>
              <img src={FooterLogo} alt='footer-logo'></img> © {new Date().getFullYear()}, Third Pillar of Health Ltd
            </div>
            <div className='footer-link'>
              <a href="/benefits">Benefits for you</a>
              <a href="/terms-and-conditions/0">Terms and conditions</a>
              <a href="/contact-us" >Contact us</a>
            </div>
          </div>
        </Container>
      </footer>
    </Fragment>
  );
};

export default FooterComp;
